<template>
  <a-card :bordered="false" style="background:#F8F9FB;margin:0 20px;">
    <div class="isdie" v-if="$store.state.cause.invaild == 1"></div>
    <a-row class="caseInput" style="margin-bottom:20px;">
      <a-col :span='4'>
        <label>{{ i.cause_type == 1 ? '诉讼立案代理人' : '被申请人代理人' }}：</label>
        <span>{{ i.agent }}</span>
      </a-col>
      <a-col :span='4'>
        <label>{{ i.cause_type == 1 ? '开庭代理人' : '申请人代理人' }}：</label> <span v-if='i.step_dpj.length > 0'>{{
          i.step_dpj[0].agent }}</span>
      </a-col>
      <a-col :span='5'>
        <label>执行立案代理人：</label><span>{{ i.exec_la_agent }}</span>
      </a-col>
      <a-col :span='5'>
        <label>执行代理人：</label><span>{{ i.exec_agent }}</span>
      </a-col>
      <a-col :span='6'>
        <label>是否留置车辆：</label><span>{{ i.is_retain_car | rCar }}</span>
      </a-col>
    </a-row>
    <a-row class="caseInput" style="margin-bottom:20px;">
      <a-col :span='4' v-if='i.cause_type == 1'>
        <label>是否为重审案件：</label>
        <span>{{ i.is_retrial ? (i.is_retrial == 1 ? '是' : '否') : '' }}</span>
      </a-col>
      <a-col :span='4' style="display: flex;" v-else>
        <label>调解机构：</label>
        <Normap :tit='i.arb_org | NullTit'></Normap>
      </a-col> .
      <a-col :span='4'>
        <label>车辆是否首封：</label> <span>{{ i.is_first_ban == 0 ? '不详' : (i.is_first_ban == 1 ? '是' : '否') }}</span>
      </a-col>
      <a-col :span='5'>
        <label>是否申请拒执：</label>{{ i.is_payee_cancel | payee }}
      </a-col>
      <a-col :span='5'>
        <label>是否支持优先受偿：</label><span>{{ i.is_first_compensation | retain }}</span>
      </a-col>
      <a-col :span='5' style="display: flex;">
        <label style="white-space: nowrap;">是否分期还款履行中：</label>
        <span v-if="i.in_loan == 1"><b>
            <font color='#f00'>是</font>
          </b></span>
        <span v-else>否</span>
      </a-col>
    </a-row>
    <a-row class="caseInput" style="margin-bottom:20px;" type="flex">
      <a-col :span='4' v-if="i.cause_type == 1">
        <label>本案代偿时间：</label>
        <span v-if='i.compensation_time'>{{ i.compensation_time | yearFormat }}</span>
      </a-col>
      <a-col :span='4' v-else>
        <label>民初案号：</label>
        <span v-if='i.mc_la_step && i.mc_la_step.length'>{{ i.mc_la_step[0].no }}</span>
      </a-col>
      <a-col :span='4'>
        <label>{{ i.cause_type == 1 ? '被告' : '被申请人' }}：</label> <span>{{ debInfo.realname }}</span>
      </a-col>
      <a-col :span='5'>
        <label>{{ i.cause_type == 1 ? '诉讼' : '调解' }}案号：</label> <span>{{ i.no }}</span>
      </a-col>
      <a-col :span='5'>
        <label>当前进度：</label>
        <span v-if='hasjdList.length > 0'>{{ hasjdList[hasjdList.length - 1].title }}</span>
      </a-col>
      <a-col :span='6' style="display: flex;">
        <label>{{ i.cause_type == 1 ? '原告' : '申请人' }}：</label>
        <span v-if='i.accuser' style="width:80%;">
          <Normap :tit='i.accuser.title'>{{ i.accuser.title }}</Normap>
        </span>
      </a-col>
    </a-row>
    <a-row class="caseInput" style="margin-bottom:20px;">
      <a-col :span='4'>
        <label>案由：</label> <span v-if='i.reason'>{{ i.reason.title }}</span>
      </a-col>
      <a-col :span='4'>
        <label>业务来源：</label> <span v-if='i.team'>{{ i.team.title }}</span>
      </a-col>
      <a-col :span='5'>
        <label>贷款机构：</label><span v-if='i.bank'> {{ i.bank.title }}</span>
      </a-col>
      <a-col :span='5'>
        <label>执行案号：</label><span v-if='i.exec_la_step.length > 0'>{{ i.exec_la_step[0].no }}</span>
      </a-col>
      <a-col :span='6' style="display: flex;">
        <label style="white-space: nowrap;">管辖法院：</label>
        <Normap :tit='i.court | rCity' style="overflow: hidden;white-space: nowrap; text-overflow: ellipsis;"></Normap>
      </a-col>
    </a-row>
    <a-modal :visible="noteVisible" @cancel="noteVisible = false" title='特殊备注' width='460px' @ok='markSub(index)'>
      <a-row align='top' type='flex'>
        <label>特殊备注：</label>
        <div>
          <a-textarea placeholder='请输入特殊备注' @change="textareaChange" v-model='note' style="width:300px;height:120px;">
          </a-textarea>
        </div>
      </a-row>
    </a-modal>
    <a-row class="caseInput">
      <a-col :span='24' style="display:flex;">
        <label style="white-space: nowrap;">特殊备注：</label>
        <span
          v-if='$common.AccAUTH(i.accuser_id, (!i.note ? "cause:innerCommnet:add" : ($store.state.cause.invaild == 0 ? "cause:innerCommnet:read" : "cause:invalid:innerComment:read")))'>{{
            i.note }}
        </span>
        <a href='javascript:void(0);'
          v-if='!isEdit("note", i.audit) && $common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? "cause:innerComment:edit" : "cause:invaild:innerComment:edit")'
          @click='note = JSON.parse(JSON.stringify(i.note)); noteVisible = true; inputChange = true'
          style="white-space: nowrap;margin-left:10px;"> {{ i.note ? '修改' : '新增' }}</a>
        <font color='#f00' v-if='isEdit("note", i.audit)' style="margin-left:10px;white-space: nowrap;">审核中</font>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { causeEditNote } from '@/server/debtor'
export default {
  name: "CaseInfo",
  props: {
    hasjdList: Array,
    i: Object,
    index: Number
  },
  data() {
    return {
      note: "",  //备注
      noteVisible: false,
      inputChange: true
    }
  },
  filters: {
    rCity(val) {
      let cityArr = val.split(",")
      cityArr.splice(2, 1)
      return cityArr.toString()
    },
    retain(val) {
      if (val) {
        const retainList = [
          { name: "不详", value: 0 },
          { name: "支持", value: 1 },
          { name: "未支持", value: 2 },
          { name: "未主张", value: 3 },
        ]
        return retainList[val].name
      } else {
        return "不详"
      }
    }
  },
  computed: {
    ...mapGetters([
      'debInfo',
      'caselist'
    ])
  },
  methods: {
    markSub(index) {    //特殊备注修改
      if (!this.note) {
        this.$message.error('请输入特殊备注')
        return false;
      }
      causeEditNote({ note: this.note, id: this.$store.state.cause.id }).then(e => {
        this.$message.success('已提交审核')
        let caselist = JSON.parse(JSON.stringify(this.caselist))
        let audit = caselist[index].audit
        audit.push({ field: "note" })
        this.$store.dispatch('Case/putInData', { index: index, key: "note", value: this.note })
        this.$store.dispatch('Case/putInData', { index: index, key: "audit", value: audit })
        this.noteVisible = false;
      })
    },
    isEdit(val, audit) {
      let bool = audit.filter(ele => {
        return val == ele.field
      }).length > 0 ? true : false;
      return bool
    },
    textareaChange(e) {
      this.inputChange = false
    },
  }
}
</script>